module.exports = __webpack_public_path__ + "static/media/100x100-02-01.7e4c13cb.png";